import { useGetContractFamilyPipelineConfigurationQuery } from "@/api/contract-family-pipeline";
import type { PipelineConfigurationResponse } from "@/types/contract-family-pipeline";

/** The parts of the organisation's Contract Family settings a contract summary cannot run without. */
export const missingContractSummarySettings = (
  configuration: PipelineConfigurationResponse,
  { requireBaseCollection = false }: { requireBaseCollection?: boolean } = {},
): string[] => [
  ...(configuration.fixed_template_id ? [] : ["Snapshot Template"]),
  ...(configuration.default_family_collection_id ? [] : ["Master Collection"]),
  ...(!requireBaseCollection || configuration.default_base_collection_id ? [] : ["Supplier Base Collection"]),
  ...(configuration.publisher_user_id ? [] : ["Publisher"]),
];

/**
 * Checks the Contract Family settings as soon as a contract summary dialog opens, so an incomplete
 * setup is explained before the user confirms. When the settings cannot be read, nothing is reported
 * as missing and the request itself decides.
 */
export const useContractSummaryReadiness = (
  open: boolean,
  // Only the folder one-click run snapshots into the base collection; the collection-level run adopts its own.
  options: { requireBaseCollection?: boolean } = {},
) => {
  const configuration = useGetContractFamilyPipelineConfigurationQuery(undefined, { skip: !open });

  return {
    isChecking: open && Boolean(configuration.isLoading),
    missing: configuration.data ? missingContractSummarySettings(configuration.data, options) : [],
    mismatch: configuration.data?.master_collection_mismatch ?? null,
  };
};
